import { render, staticRenderFns } from "./StatusContent.vue?vue&type=template&id=8213e1f0&scoped=true"
import script from "./StatusContent.vue?vue&type=script&lang=js"
export * from "./StatusContent.vue?vue&type=script&lang=js"
import style0 from "./StatusContent.vue?vue&type=style&index=0&id=8213e1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8213e1f0",
  null
  
)

export default component.exports